import { ColDef } from "../../records/grids/columns/colDef";
import { GridArgs } from "../../records/grids/gridArgs";

export const vsServiceName = "machineConfigurationCellClassService";
export const vsProviderName = `${vsServiceName}Provider`;

export type gridCellClass = (cellClassParams: any) => string | string[];

export class MachineConfigurationCellClassServiceProvider {
  constructor() {}

  $get = [
    "environment",
    (environment: any) =>
      new MachineConfigurationCellClassService(
        machineConfigurationCellClass(
          environment.Date,
          "CurrentConfiguration",
          "Date"
        )
      ),
  ];
}

export class MachineConfigurationCellClassService {
  constructor(private readonly machineConfigurationCellClass: gridCellClass) {}

  styleColumns(columns: ColDef[] | undefined, showStyle: boolean) {
    columns?.forEach(
      (c) =>
        (c.cellClass = showStyle
          ? this.machineConfigurationCellClass
          : undefined)
    );
  }
}

const currentConfigurationClasses = ["currentConfiguration"];
const pendingConfigurationClasses = ["pendingConfiguration"];

function machineConfigurationCellClass(
  systemDate: Date,
  currentConfigurationField: string,
  machineConfigurationDateField: string
) {
  return (args: GridArgs) => {
    const currentConfiguration: boolean = args.data[currentConfigurationField];
    const machineDate: Date = args.data[machineConfigurationDateField];

    const pendingConfiguration = machineDate > systemDate;

    return pendingConfiguration
      ? pendingConfigurationClasses
      : currentConfiguration
      ? currentConfigurationClasses
      : [];
  };
}
